import { atom, useAtom } from 'jotai';

export const appsIsIframeRunAtom = atom<boolean>(false);
export const layoutSidebarHiddenAtom = atom<boolean>(false);
const selectedAppAtom = atom<string>('');

export const useAppsIframe = () => {
  const [isIframeRun, setIframeRun] = useAtom(appsIsIframeRunAtom);
  const [isSidebarHidden, setSidebarHidden] = useAtom(layoutSidebarHiddenAtom);
  const [selectedApp, setSelectedApp] = useAtom(selectedAppAtom);

  return {
    isIframeRun,
    setIframeRun,
    isSidebarHidden,
    setSidebarHidden,
    selectedApp,
    setSelectedApp,
  };
};
